import React from "react"
import RecipesFilter from "./RecipesFilter"
import OffcanvasFilters from "./OffcanvasFilters"

const OffcanvasFiltersHoc = (props) => {
  if (window.innerWidth > 992) {
    return <RecipesFilter />
  } else {
    return (
      <OffcanvasFilters {...props}>
        <RecipesFilter />
      </OffcanvasFilters>
    )
  }
}
export default OffcanvasFiltersHoc
